export default __webpack_public_path__ + "static/media/interviewnotes.0dffabb1.png";